"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.linkCtaPropType = exports.imagePropType = exports["default"] = exports.articlePropType = exports.articleInfoPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.imagePropType = imagePropType;
var linkCtaPropType = _propTypes["default"].shape({
  url: _propTypes["default"].string,
  label: _propTypes["default"].string,
  priority: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool,
  theme: _propTypes["default"].string
});
exports.linkCtaPropType = linkCtaPropType;
var articleInfoPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  mainHeading: _propTypes["default"].string,
  paragraph: _propTypes["default"].string,
  link: linkCtaPropType,
  image: imagePropType
});
exports.articleInfoPropType = articleInfoPropType;
var articlePropType = _propTypes["default"].shape({
  date: _propTypes["default"].string,
  articleInformation: articleInfoPropType
});
exports.articlePropType = articlePropType;
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  viewMoreLabel: _propTypes["default"].string,
  type: _propTypes["default"].string,
  limit: _propTypes["default"].number,
  pageSize: _propTypes["default"].number,
  articles: _propTypes["default"].arrayOf(articlePropType)
});
var _default = PROP_TYPES;
exports["default"] = _default;